import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient-emergency-contacts',
  templateUrl: './patient-emergency-contacts.component.html',
  styleUrls: ['./patient-emergency-contacts.component.scss'],
  standalone: false
})
export class PatientEmergencyContactsComponent implements OnInit {
  @Input() emergencyContacts: any[] = [];

  ngOnInit(): void {
    // Ensure emergencyContacts is an array
    if (!this.emergencyContacts || !Array.isArray(this.emergencyContacts)) {
      this.emergencyContacts = [];
    }
  }

  /**
   * Format field values, showing "None" for null/undefined/empty values
   */
  formatFieldValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return 'None';
    }
    return value.toString();
  }

  /**
   * Format phone numbers for better display
   */
  formatPhoneNumber(phone: any): string {
    if (phone === null || phone === undefined || phone === '') {
      return 'None';
    }
    return phone.toString();
  }

  /**
   * Get status display info based on inactiveFlag
   */
  getStatusInfo(inactiveFlag: number): { text: string; icon: string; class: string } {
    if (inactiveFlag === 1) {
      return {
        text: 'Inactive',
        icon: 'close',
        class: 'inactive-status'
      };
    } else {
      return {
        text: 'Active',
        icon: 'check',
        class: 'active-status'
      };
    }
  }

  /**
   * Format date values
   */
  formatDate(date: any): string {
    if (date === null || date === undefined || date === '') {
      return 'None';
    }
    try {
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        return 'None';
      }
      return dateObj.toLocaleDateString();
    } catch {
      return 'None';
    }
  }
}
